import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { deleteMomento } from "../store/actions/MomentosActions";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const DeleteModal = ({ modal, toggle, ID, uid }) => {
    const dispatch = useDispatch();
    return (
        <div>
            {" "}
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Modal title</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this memento?
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="danger"
                        onClick={() =>
                            dispatch(
                                deleteMomento(ID, uid, () => {
                                    toast.success(
                                        "Memento Deleted Successfully"
                                    );
                                    toggle();
                                })
                            )
                        }
                    >
                        Delete
                    </Button>{" "}
                    <Button color="primary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default DeleteModal;
